import dataProcessing from './notifications/dataProcessing';

/**
 * Notification action handler by action keys
 */
export const actionHandler = {
    showJobInList(notification, data) {
        this.$router.push({ name: 'DashboardJob', params: { job: data }}).catch(err => {});
    }
}

/**
 * Handles notification actions.
 * 
 * @param {Object} notification The notification
 * @param {string} actionKey The key of the action to handle
 * @param {Object} actionData The data of the action handle
 */
export function handleAction(notification, actionKey, actionData) {
    if(actionKey == 'logout') {
        this.$store.commit('user/logout');
        this.$router.push('/login');
        return true;
    }

    if(actionKey in actionHandler) {
        actionHandler[actionKey].call(this, notification, actionData);
    }
}

/**
 * Handles new notifications.
 * 
 * @param {Array} newNotifications 
 */
export function handleNew(newNotifications, source) {
    const dataProcessingKeys = Object.keys(dataProcessing);
    const dataProcessingItems = Object.fromEntries(dataProcessingKeys.map(key => [ key, [] ]));
    const dataProcessingPromises = [];

    for(const notification of newNotifications) {
        for(const processingKey of dataProcessingKeys) {
            if(dataProcessing[processingKey].shouldProcess.call(this, notification, source)) {
                dataProcessingItems[processingKey].push(notification);
            }
        }
    }

    for(const processingKey of dataProcessingKeys) {
        if(dataProcessingItems[processingKey].length) {
            dataProcessingPromises.push(dataProcessing[processingKey].process.call(this, dataProcessingItems[processingKey], source));
        }
    }

    return Promise.all(dataProcessingPromises);
}
